import request from '../../utils/requests'
/** * Tag: Finance */
const baseUrl ="/api/Finance";

/** * 获取机构账户 */async function _getOrgAccount() {  return request(baseUrl+'/getOrgAccount',{    method: 'GET',  });
}

/** * 设置账户 * @param {*} body * { *    AccountName Desc:开户姓名 Required:true *    CardCode Desc:银行卡号 Required:true *    CardBelongBank Desc:所属银行 Required:true *    CardBindingMobile Desc:预留手机号 Required:true * } */async function _setOrgAccount(body) {  return request(baseUrl+'/setOrgAccount',{    method: 'POST',    body: body,  });
}

/** * 体现申请 * @param {*} param * { *    amount Desc: Required:true * } */async function _withdrawApply(param) {  return request(baseUrl+'/withdrawApply',{    method: 'GET',    params: param,  });
}

/** * 获取机构提现记录 * @param {*} body * { *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _getOrgWithdrawRecord(body) {  return request(baseUrl+'/getOrgWithdrawRecord',{    method: 'POST',    body: body,  });
}

/** * 获取机构钱包 */async function _getOrgWallet() {  return request(baseUrl+'/getOrgWallet',{    method: 'GET',  });
}

/** * 钱包充值 返回订单编号 * @param {*} param * { *    amount Desc:充值金额 Required:true * } */async function _walletRecharge(param) {  return request(baseUrl+'/walletRecharge',{    method: 'GET',    params: param,  });
}

/** * 获取支付二维码 返回base64 * @param {*} param * { *    ordercode Desc:订单编号 Required:true *    channel Desc:支付渠道  1：微信；2：支付宝 Required:true * } */async function _createPayQRCode(param) {  return request(baseUrl+'/createPayQRCode',{    method: 'GET',    params: param,  });
}

/** * 扫描枪支付 * @param {*} param * { *    ordercode Desc:订单号 Required:true *    authcode Desc:扫描枪结果 Required:true * } */async function _barcodePay(param) {  return request(baseUrl+'/barcodePay',{    method: 'GET',    params: param,  });
}

/** * 判断是否支付 * @param {*} param * { *    ordercode Desc: Required:true * } */async function _checkIsPaid(param) {  return request(baseUrl+'/checkIsPaid',{    method: 'GET',    params: param,  });
}

export default{  _getOrgAccount,  _setOrgAccount,  _withdrawApply,  _getOrgWithdrawRecord,  _getOrgWallet,  _walletRecharge,  _createPayQRCode,  _barcodePay,  _checkIsPaid}



// WEBPACK FOOTER //
// ./src/services/finance.js